<template>
  <div>
    <div
      class="cardLayoutWrapper"
      v-if="item"
    >
      <div class="elem elem--span-1">
        <BasicTooltip label="Avec mandat de gestion">
          <BasicIcon
            v-if="item.estSousMandatGestion"
            name="document-text"
            active
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-1">
        <BasicTooltip label="Avec subrogation">
          <BasicIcon
            v-if="item.avecSubrogation"
            name="wallet"
            :active="false"
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-3 elem--clickable">
        <span @click="ouvrirDemande(item)">
          {{ item?.id }}
        </span>
      </div>
      <div class="elem elem--span-13 elem--nowrap">{{ item?.sousDispositif ? SousDispositifLibelle[item?.sousDispositif as SousDispositif ] : ''}}</div>



      <div class="elem elem--span-10 elem--nowrap">
        <span>
          {{ item?.adherent?.denomination }}
        </span>
      </div>

      <div class="elem elem--span-4">
        <BasicTooltip :label="StatutLibelle[item.statut]">
          <BasicBadge
            :type="explicitCast(StatutBadgeType[item.statut])"
            :deletable="false"
            :label="StatutLibelle[item.statut]"
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-1 elem--clickable"></div>
      <BasicTooltip :label="readonly ? 'Voir la demande' : 'Modifier la demande'">
        <div
          v-focusable="{ onEnter: () => ouvrirDemande(item) }"
          class="elem elem--span-1 elem--clickable"
        >
          <BasicIcon
            :name="readonly ? 'eye' : 'edit'"
            :active="false"
            @click="ouvrirDemande(item)"
          />
        </div>
      </BasicTooltip>
      <div
        v-if="checkClonePermission(item.dispositif)"
        v-focusable="{
          onEnter: clickClone,
        }"
        class="elem elem--span-1 elem--clickable"
      >
        <BasicTooltip label="Dupliquer la demande">
          <BasicIcon
            name="duplicate"
            :active="false"
            @click="clickClone"
          />
        </BasicTooltip>
      </div>
      <div
        v-focusable="{
          focusable: !readonly,
          onEnter: () => deleteDemande(item.id),
        }"
        class="elem elem--span-1 elem--clickable elem--danger"
      >
        <BasicTooltip
          v-if="deletable"
          label="Supprimer la demande"
        >
          <BasicIcon
            name="trash"
            :active="false"
            @click="deleteDemande(item.id)"
          />
        </BasicTooltip>
      </div>
    </div>
    <Transition name="open">
      <div
        v-if="showDrawer && (stagiairesList.length || prestatairesList.length)"
        class="listDrawerWrapper"
      >
        <div class="content">
          <ListDetails>
            <template #content>
              <div
                class="listDetailsElement"
                v-if="stagiairesList.length"
              >
                <span class="listDetailsTitle">Stagiaire(s)</span>
                <span class="listDetailsSubtitle">
                  {{ stagiairesList }}
                </span>
              </div>
              <div
                class="listDetailsElement"
                v-if="prestatairesList.length"
              >
                <span class="listDetailsTitle">Organisme(s)</span>
                <span
                  class="listDetailsSubtitle"
                  v-for="item in prestatairesList"
                  :key="item"
                >
                  {{ item }}
                </span>
              </div>
            </template>
          </ListDetails>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import type { RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { StatutBadgeType, StatutLibelle } from '@/features/domaine/types/opco'
import { SousDispositif, SousDispositifLibelle } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { explicitCast } from '@/features/interface/shared/tools'
import { ref } from 'vue'
import { useDemandeTtHelper } from '../useDemandeHelper'
import { useRechercheDemandeTTActions } from '../useRechercheDemandeTTActions.ts'
import ListDetails from './ListDetails.vue'

  const { cloneDemande, deleteDemande, ouvrirDemande } = useRechercheDemandeTTActions()

  const props = defineProps<{ item: RechercheResultDTO }>()
  const { readonly, stagiairesList, prestatairesList, checkClonePermission, deletable } = useDemandeTtHelper(
    props.item,
  )
  const showDrawer = ref(false)

  const clickClone = () => {
    return cloneDemande({
      dispositif: props.item.dispositif,
      idDemande: props.item.id,
      idcc: props.item.adherent.idcc!.code,
      siret: props.item.adherent.siret.valeur!,
      permissions: props.item.niveauPermission,
      sousDispositif: props.item.sousDispositif,
      codeDrf: null
    })
  }
</script>

<style scoped>
  @import '../../index.less';
</style>

